import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-1.5" }
const _hoisted_2 = { class: "flex items-center gap-1.5" }

import { computed } from 'vue';
    import {
        Select,
        SelectContent,
        SelectGroup,
        SelectItem,
        SelectTrigger,
        SelectValue,
    } from '@/components/ui/select';
    import type { DataTableSelectOption } from '@/types';
    import Indicator from '@/components/Indicator.vue';
    import type { AcceptableValue } from 'reka-ui';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableSelect',
  props: {
    modelValue: {},
    options: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const selectedOption = computed(() => {
        return props.options.find((option) => option.value === props.modelValue);
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Select), {
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event as number)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(SelectTrigger), { class: "border-none px-0 shadow-none" }, {
        default: _withCtx(() => [
          _createVNode(_unref(SelectValue), null, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, [
                _createVNode(Indicator, {
                  variant: selectedOption.value?.color
                }, null, 8, ["variant"]),
                _createTextVNode(" " + _toDisplayString(selectedOption.value?.label), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(SelectContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(SelectGroup), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                return (_openBlock(), _createBlock(_unref(SelectItem), {
                  key: option.label,
                  value: option.value
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, [
                      _createVNode(Indicator, {
                        variant: option.color
                      }, null, 8, ["variant"]),
                      _createTextVNode(" " + _toDisplayString(option.label), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})